export default __webpack_public_path__ + "locales/it/Webhooks.json?hash=cfd974131cc6605362e51802559193e0";